import type { ReactNode, RefObject } from 'react'
import { observer } from 'mobx-react-lite'
import { ConversationView } from '@/features/messaging/components/ConversationView'
import { type WelcomeAction } from '@/features/messaging/components/ConversationView/Messages/Welcome'
import { ConversationComposerContainer } from '@/features/messaging/components/ConversationView/ConversationComposer/ConversationComposerContainer'
import { MessagesContainer } from '@/features/messaging/components/ConversationView/Messages/MessagesContainer'
import { TypingIndicator } from '@/features/messaging/components/ConversationView/TypingIndicator'
import { type ConversationViewModel } from '@/features/messaging/ConversationViewModel'

export interface ConversationViewContainerProps {
  vm: ConversationViewModel
  header?: ReactNode
  banner?: ReactNode
  welcomeActions?: WelcomeAction[]
  readOnly?: boolean
  scrollRef?: RefObject<HTMLDivElement | null>
  /** @see ConversationComposerProps.leadingActions */
  composerLeadingActions?: ReactNode
  /** @see ConversationComposerProps.trailingActions */
  composerTrailingActions?: ReactNode
}

export const ConversationViewContainer = observer(
  function ConversationViewContainer({
    vm,
    header,
    banner,
    welcomeActions,
    readOnly,
    scrollRef,
    composerLeadingActions,
    composerTrailingActions,
  }: ConversationViewContainerProps) {
    return (
      <ConversationView
        header={header}
        banner={banner}
        renderMessages={(small) => (
          <MessagesContainer
            scrollRef={scrollRef}
            vm={vm}
            small={small}
            welcomeActions={welcomeActions}
          />
        )}
        composer={
          !readOnly && (
            <>
              <ConversationComposerContainer
                vm={vm}
                leadingActions={composerLeadingActions}
                trailingActions={composerTrailingActions}
              />
              <TypingIndicator />
            </>
          )
        }
      />
    )
  },
)
